










































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import UUIFComponents from '@/shared/uuifComponent';
import { CustomMessagePopupConfig } from './types/index';
const cssPrefix = 'customMessagePopup';
@Component({
  components:{
    SwStatusInfo,
    ...UUIFComponents,
  },
})
export default class CustomMessagePopup extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showCustomMessagePopup: any;
  @Prop()
  customMessagePopupConfig: CustomMessagePopupConfig;
  mounted() {
  }
  getButtonText(value: any) {
    if (value === 'default') {
      return this.customMessagePopupConfig.defaultButtonText;
    }
    return this.customMessagePopupConfig.nonDefaultButtonText;
  }
  get getMsgText() {
    return this.customMessagePopupConfig.msgText;
  }
  get getInfoType() {
    return this.customMessagePopupConfig.msgType;
  }
  get popupWidth() {
    return this.customMessagePopupConfig.width;
  }
  onClickConfirm() {
    this.$emit('on-process-secure-upgrade');
  }
  onClickCancel() {
    this.$emit('on-close-popup');
  }
}
